import { withInstall } from '@xzx-design/utils'
import _Toast from './src/toast'

export const Toast = withInstall(_Toast)
export default Toast

export * from './src/toast'
export * from './src/types'
export * from './src/function-call'
